import clsx from "clsx";

import styles from "./featured-image-section.module.scss";

const FeaturedImageSection = ({
  desktopImage,
  mobileImage,
  title,
  description,
  callToAction,
  reverse = false,
  mobileDescriptionFirst = false
}) => {
  return (
    <div className={styles.FeaturedImageSection}>
      <div
        className={clsx("container", styles.Wrapper, reverse && styles.Reverse)}
      >
        <div className={styles.DesktopImage}>{desktopImage}</div>
        <div className={styles.Content}>
          {title && <h2>{title}</h2>}

          {mobileDescriptionFirst && description && (
            <p className={styles.MobileDescriptionFirst}>{description}</p>
          )}

          <div className={styles.MobileImage}>{mobileImage}</div>

          {!mobileDescriptionFirst && description && (
            <p className={styles.MobileDescription}>{description}</p>
          )}

          {callToAction}
        </div>
      </div>
    </div>
  );
};

export default FeaturedImageSection;
